/** La galería: una tarjeta grande por fila, con un trozo de su texto y sus valores. */
import { IconoDePagina } from '../Arbol'
import type { AccionesDeVista } from './BaseVista'
import { ValoresEnTarjeta } from './Tablero'

export function Galeria(p: AccionesDeVista) {
  const { esquema, vista, filas, editable } = p
  const ocultas = new Set(vista.hidden ?? [])
  const visibles = esquema.properties.filter((c) => !ocultas.has(c.id))

  return (
    <div className="galeria">
      {filas.map((f) => (
        <article key={f.id} className="galeria__tarjeta" tabIndex={0} onClick={() => p.alAbrir(f.id)}
                 onKeyDown={(e) => e.key === 'Enter' && p.alAbrir(f.id)}>
          <div className="galeria__portada">
            {f.resumen ? <p>{f.resumen}</p> : <span className="galeria__sin-texto">Sin contenido</span>}
          </div>
          <div className="galeria__cuerpo">
            <div className="tarjeta-bd__titulo">
              <IconoDePagina icono={f.icon} tam={16} /> {f.title || 'Sin título'}
            </div>
            <ValoresEnTarjeta fila={f} visibles={visibles} />
          </div>
        </article>
      ))}
      {editable && (
        <button className="galeria__nueva" onClick={() => p.alNuevaFila()}>＋ Nueva</button>
      )}
      {filas.length === 0 && !editable && <div className="bd__vacio">Esta base está vacía.</div>}
    </div>
  )
}
